/**
 * Full-height pass-through wrapper for full-page experiences that supply
 * their own left navigation + top bar (Organization Settings and its
 * sub-routes, via OrgSettingsLayout.tsx).
 *
 * Previously rendered a single combined header (toggle + logo + user menu)
 * of its own. Restructured (2026-09-01) so the toggle/logo/user-menu live
 * in OrgSettingsLayout instead, split the same way the main app splits them:
 * Sidebar.tsx owns the logo in its own header row, Header.tsx owns only the
 * collapse toggle + user menu in a separate top bar. This wrapper now just
 * provides the full-height sizing context, matching the role Layout.tsx
 * plays for the main app's <Sidebar/> + content column.
 */

import React from 'react'

interface NoSidebarLayoutProps {
  children: React.ReactNode
}

const NoSidebarLayout: React.FC<NoSidebarLayoutProps> = ({ children }) => (
  <div className="h-screen bg-gray-50 flex flex-col overflow-hidden">
    {children}
  </div>
)

export default NoSidebarLayout
